export const mgPlatformMinusIcon = {
  data: `<svg viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.25 1.25L0.75 1.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'minus'
}
